import { useEffect } from 'react'
import { FieldErrors, FieldValues } from 'react-hook-form'
import useAnalytics from './useAnalytics'
import usePageErrorMessages from './usePageErrorMessages'

const useFormAnalytics = <T extends FieldValues>(formName: string, additionalErrorMessages?: string) => {
  const { onOther } = useAnalytics(`${formName}_form`)

  const pageErrorMessages = usePageErrorMessages()
  useEffect(() => {
    const trimmedAdditionalErrorMessages = additionalErrorMessages?.trim()
    const errorMessages = [
      trimmedAdditionalErrorMessages ? `${trimmedAdditionalErrorMessages} ` : ``,
      pageErrorMessages,
    ].join('')
    if (errorMessages) {
      onOther(`error`, { description: errorMessages })
    }
  }, [onOther, additionalErrorMessages, pageErrorMessages])

  return {
    onSubmit: () => onOther(`submit`),
    onOther,
    onError: (errors: FieldErrors<T>) =>
      Object.keys(errors).map((name) => onOther(`${name}_error`, { description: errors[name]?.message })),
    onBlur: (e: React.FocusEvent<HTMLFormElement, Element>) => onOther(`${e.target.name}_blur`),
  }
}

export default useFormAnalytics
